import { Link } from "react-router-dom";
import { MapPin, ThumbsUp, Calendar, Sparkles } from "lucide-react";
import { formatDate } from "@/lib/format";

export default function EventCard({ event }) {
  const dateLabel = formatDate(event.event_date);
  return (
    <Link
      to={`/event/${event.id}`}
      data-testid={`event-card-${event.id}`}
      className={`group relative flex flex-col gap-3 bg-white p-3 rounded-2xl border transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] ${
        event.is_sponsored ? "border-[#FA003F]/60 ring-1 ring-[#FA003F]/20" : "border-black/10 hover:border-[#FA003F]/40"
      }`}
    >
      <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden bg-gray-100">
        {event.image_url && (
          <img
            src={event.image_url}
            alt={event.title}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
          />
        )}
        <div className="absolute top-3 right-3 flex flex-col items-end gap-1.5">
          {event.is_sponsored && (
            <div className="bg-[#FA003F] text-white text-[10px] font-black uppercase tracking-widest px-2.5 py-1 rounded-full shadow inline-flex items-center gap-1">
              <Sparkles className="h-3 w-3" /> Sponsored
            </div>
          )}
          {event.is_trending && !event.is_sponsored && (
            <div className="bg-[#FA003F] text-white text-[10px] font-black uppercase tracking-widest px-2.5 py-1 rounded-full shadow">
              Trending
            </div>
          )}
        </div>
        <div className="absolute bottom-3 left-3 flex items-center gap-2">
          <span className="bg-white/95 backdrop-blur text-[#1A1A1A] text-[11px] font-bold px-2.5 py-1 rounded-md flex items-center gap-1.5">
            <Calendar className="h-3 w-3 text-[#FA003F]" />
            {dateLabel} · {event.event_time}
          </span>
        </div>
      </div>

      <div className="flex flex-col gap-1 px-1">
        <h3 className="font-display text-[17px] font-bold leading-snug line-clamp-2">
          {event.title}
        </h3>
        <div className="flex items-center gap-1.5 text-xs text-gray-500">
          <MapPin className="h-3.5 w-3.5" />
          <span className="truncate">
            {event.venue} {event.address ? `· ${event.address.split(",")[0]}` : ""}
          </span>
        </div>
      </div>

      <div className="flex items-center justify-between mt-1 pt-3 border-t border-black/5 px-1">
        <div className="flex items-center gap-1.5 text-xs text-gray-600">
          <ThumbsUp className="h-3.5 w-3.5 text-[#E91E63]" />
          <span className="font-bold">{event.interests_count || 0}</span>
          <span className="text-gray-400">interests</span>
        </div>
        <div className="text-right">
          {event.is_free || event.price === 0 ? (
            <span className="inline-flex items-center gap-1.5 text-emerald-600 text-sm font-black">
              <span className="h-2 w-2 rounded-full bg-emerald-500" /> Free
            </span>
          ) : (
            <span className="text-sm font-black text-[#FA003F]">₹ {event.price}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
